var _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCkExtra(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "CK_Extra-Logo_Horizontal_Positive",
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.053,
    height: 31.965,
    viewBox: "0 0 193.053 31.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_5926",
    "data-name": "Path 5926",
    d: "M320.447,16.335V13.613a7.537,7.537,0,0,0-6.617,4.777V13.57h-2.589l-.011,17.492h2.6V24.229c0-4.6,2.463-7.234,5.691-7.759,0,0,.364-.054.926-.13Z",
    transform: "translate(-139.768 -6.228)",
    fill: "#ed8b00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5927",
    "data-name": "Path 5927",
    d: "M336.066,15.528a7.831,7.831,0,0,0-5.641-1.888h-2.65V16.1c.832-.081,1.686-.141,2.38-.141,3.278,0,5.168,1.591,5.168,4.642v.53a18.537,18.537,0,0,0-5.333-.73c-4.424,0-7.459,1.921-7.459,5.605v.065c0,3.517,3.239,5.34,6.517,5.34a7.7,7.7,0,0,0,6.28-2.916v2.554H337.9V20.565a6.715,6.715,0,0,0-1.824-5.043Zm-.711,9.219c0,2.721-2.6,4.61-5.807,4.61-2.363,0-4.391-1.261-4.391-3.414v-.065c0-2.056,1.857-3.446,5.1-3.446a18.084,18.084,0,0,1,5.1.73v1.591Z",
    transform: "translate(-144.843 -6.26)",
    fill: "#ed8b00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5928",
    "data-name": "Path 5928",
    d: "M243.111,29.1a7.328,7.328,0,0,0,5.537-2.435l1.631,1.434a9.127,9.127,0,0,1-7.234,3.235,8.658,8.658,0,0,1-8.765-9.008c0-5,3.564-9.008,8.424-9.008,5.2,0,8.187,4.069,8.187,9.138,0,.233,0,.5-.033.9H236.93a6.091,6.091,0,0,0,6.181,5.735Zm5.129-7.807c-.3-3.138-2.138-5.805-5.6-5.805-3.025,0-5.333,2.467-5.707,5.805Z",
    transform: "translate(-105.211 -6.113)",
    fill: "#ed8b00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5929",
    "data-name": "Path 5929",
    d: "M293.6,22V3.92h2.644V9.179h5.63v2.294h-5.63V21.655c0,2.126,1.2,2.9,2.986,2.9a5.629,5.629,0,0,0,2.573-.606v2.224a6.762,6.762,0,0,1-3.2.741c-2.848,0-5.013-1.385-5.013-4.923Z",
    transform: "translate(-131.846 -1.799)",
    fill: "#ed8b00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5930",
    "data-name": "Path 5930",
    d: "M271.436,22.086l6.694-8.451.1-.124h-3.151L269.86,20.2l-5.19-6.666-.022-.027h-3.223l6.76,8.64-7.035,8.943H264.3l5.493-7.066,5.432,7.039.022.027h3.25Z",
    transform: "translate(-117.278 -6.201)",
    fill: "#ed8b00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5114",
    "data-name": "Rectangle 5114",
    width: 4.622,
    height: 17.633,
    transform: "translate(18.808 7.169)",
    fill: "#da291c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5932",
    "data-name": "Path 5932",
    d: "M111.414,26.868h6.214v4.015H106.72V13.25h4.694Z",
    transform: "translate(-47.926 -6.081)",
    fill: "#da291c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5933",
    "data-name": "Path 5933",
    d: "M129.24,13.25h11.806v4.009h-7.184v2.922h6.864v3.706h-6.864v2.981h7.206v4.015H129.24Z",
    transform: "translate(-58.039 -6.081)",
    fill: "#da291c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5934",
    "data-name": "Path 5934",
    d: "M184.747,15.647l6.374-8.478h-6.545l-5.9,8.121V7.169h-5.724V24.8h5.724V16.68l10.181,12.893a16.752,16.752,0,0,1-8.782,2.391c-9.244,0-16.285-6.9-16.285-15.993S170.831,0,180.075,0s16.28,6.9,16.28,15.982a15.977,15.977,0,0,1-3.344,9.907l-8.269-10.237Z",
    transform: "translate(-73.555)",
    fill: "#da291c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5935",
    "data-name": "Path 5935",
    d: "M56.708,24.163a5.313,5.313,0,0,0,3.328-5.08c0-3.874-2.815-5.832-7.862-5.832H46.4V30.883h4.622V23.5l4.8,7.385H61.28l-4.573-6.725Zm-4.391-1.85H51.022V16.994h1.322c1.879,0,3.1.806,3.1,2.6s-1.306,2.716-3.135,2.716Z",
    transform: "translate(-20.837 -6.081)",
    fill: "#da291c"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5936",
    "data-name": "Path 5936",
    d: "M9.531,16.841A4.818,4.818,0,0,0,4.655,21.8a4.818,4.818,0,0,0,4.876,4.956A5.107,5.107,0,0,0,13.9,24.292l3.57,2.289a9.256,9.256,0,0,1-8.032,4.35,9.135,9.135,0,1,1,0-18.26,9.19,9.19,0,0,1,8.082,4.323l-3.658,2.354a4.948,4.948,0,0,0-4.33-2.505h0Z",
    transform: "translate(0 -5.815)",
    fill: "#da291c"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5937",
    "data-name": "Path 5937",
    d: "M82.351,16.841A4.818,4.818,0,0,0,77.475,21.8a4.818,4.818,0,0,0,4.876,4.956,5.107,5.107,0,0,0,4.369-2.462l3.57,2.289a9.27,9.27,0,0,1-8.032,4.35,9.135,9.135,0,1,1,0-18.26,9.19,9.19,0,0,1,8.082,4.323l-3.653,2.354a4.948,4.948,0,0,0-4.33-2.505Z",
    transform: "translate(-32.702 -5.815)",
    fill: "#da291c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCkExtra);
export default __webpack_public_path__ + "static/media/logo_ck_extra.6c1267a77b6bad713dbf93998b6527a7.svg";
export { ForwardRef as ReactComponent };